import React from 'react'
import "../styles/contact.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope , faClock, faPhone , faMapLocation } from '@fortawesome/free-solid-svg-icons';
import { faFacebook , faInstagram , faYoutube } from "@fortawesome/free-brands-svg-icons"


function Contact() {
  return (
    <div id='contact' className="contact-block">
      <p className="section-eyebrow">Reach out</p>
      <h1 className="section-title">Contact Us</h1>
      <div className="section-line" aria-hidden="true" />
      <div className='plan-des section-lead'>
      <p>
        Time & Moments both are priceless. To get quality service, Contact us now.
      </p>
      </div>

      <div className='contact-container scroll-animate-stagger'>
        <div className='physical-contact'>
          <div className='contact-holder'>
            <span><FontAwesomeIcon icon={faMapLocation} /></span>
            <div ><a href="https://maps.app.goo.gl/DaHjJa47aRrrnDVM9?g_st=iw" target='_blank' rel='noreferrer'>
            <div className='contact-data'>288/1, Shyamaprosad Palli</div>
            <div className='contact-data'>Ranaghat, Nadia, WB - 741201</div></a>
            </div>
          </div>
          <div className='contact-holder'>
            <span><FontAwesomeIcon icon={faClock} /></span>
            <div>
            <div className='contact-data'>Mon - Sat : 11:00am - 9:00pm </div>
            <div className='contact-data'>Sun : OFF </div>
            </div>
          </div>
          <div className='contact-holder'>
            <span><FontAwesomeIcon icon={faPhone} /></span>
            <div>
            <div className='contact-data'><strong>Booking Related</strong></div>
            <div className='contact-data'><a href='tel:7001385764'>+91 7001385764</a></div>
            </div>
          </div>
          <div className='contact-holder'>
            <span><FontAwesomeIcon icon={faPhone} /></span>
            <div>
            <div className='contact-data'><strong>Service Related</strong></div>
            <div className='contact-data'><a href='tel:6295798710'>+91 6295798710</a></div>
            </div>
          </div>
          <div className='contact-holder'>
            <span><FontAwesomeIcon icon={faEnvelope} /></span>
            <div>
            <div className='contact-data'><a href='mailto:weddingstoriesgroup@gmail.com'>weddingstoriesgroup@gmail.com</a></div>
            </div>
          </div>
        </div>
        <div className='online-contact'>
          <div className='social'>
            <span><a href="https://www.facebook.com/weddingstoriesfacebook/" target='_blank' rel='noreferrer'><FontAwesomeIcon icon={faFacebook} /></a></span>
            <span><a href="https://www.instagram.com/weddingstoriesinsta/" target='_blank' rel='noreferrer'><FontAwesomeIcon icon={faInstagram} /></a></span>
            <span><a href="https://www.youtube.com/@weddingstoriesyoutube" target='_blank' rel='noreferrer'><FontAwesomeIcon icon={faYoutube} /></a></span>
          
          <div className='vendor'>
            <div>Verified Canvera Partner - Club Canvera Silver Partner</div>
          </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact;